import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-help-icon',
  templateUrl: './help-icon.component.html',
  standalone: false,
})
export class HelpIconComponent {
  @Input() helpContextName: string;

  timeoutDelay: number = 500;

  showHelp: boolean = false;
  hidingTimeout: number = 0;
  helpText: string = '';

  constructor() {
    this.helpContextName = '';
  }

  ngOnInit() {
    if (this.helpContextName == 'merchant-details-account-user') {
      this.helpText =
        "Account users have access to log into the merchant's portal.";
    } else {
      this.helpText =
        'This is some brief overview information about the element in question.  For more information about this, <a href="" target="_blank">click here</a>';
    }
  }

  public handleShowHelp() {
    window.clearTimeout(this.hidingTimeout);
    this.showHelp = true;
  }

  public handleHideHelp() {
    this.hidingTimeout = window.setTimeout(() => {
      this.showHelp = false;
    }, this.timeoutDelay);
  }
}
